var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSetting2 = function SvgSetting2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M7 8.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M1.167 7.514V6.486c0-.607.496-1.109 1.108-1.109 1.056 0 1.488-.746.957-1.662a1.11 1.11 0 0 1 .408-1.51l1.01-.578a.974.974 0 0 1 1.33.35l.064.11c.525.916 1.388.916 1.919 0l.064-.11a.974.974 0 0 1 1.33-.35l1.01.577c.53.304.71.986.407 1.511-.53.916-.099 1.662.957 1.662.607 0 1.108.496 1.108 1.109v1.026c0 .607-.495 1.109-1.108 1.109-1.056 0-1.487.746-.957 1.662.304.531.123 1.208-.408 1.511l-1.009.578a.974.974 0 0 1-1.33-.35l-.064-.111c-.525-.916-1.389-.916-1.92 0l-.064.11a.974.974 0 0 1-1.33.35l-1.009-.577a1.11 1.11 0 0 1-.408-1.51c.53-.917.1-1.663-.957-1.663a1.11 1.11 0 0 1-1.108-1.109"
  })));
};
export default SvgSetting2;